import React from "react"
import { observer } from "mobx-react"
import { Row, Col } from "react-styled-flexboxgrid"
import styled from "styled-components"

import Spacer from "~/components/Spacer"
import DOBInput from "./DOBInput"
import InputTitle from "./InputTitle"
import LicenseWithState from "./LicenseWithState"
import withTranslations from "~/components/_hocs/withTranslations"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
`

@observer
class LastNameDOBLicenseLicenseState extends React.Component {
  render() {
    return (
      <Wrap>
        <Row>
          <Col lg={8} md={8} sm={8} xs={16}>
            <InputTitle>
              {this.props.translate("dob")}
              <Spacer direction="width" mobile={11} desktop={11} />
            </InputTitle>
            <Spacer desktop={16} mobile={4} />
            <DOBInput />
          </Col>
          <Col lg={8} md={8} sm={8} xs={16}>
            <LicenseWithState labelGap={16} />
          </Col>
        </Row>
      </Wrap>
    )
  }
}

export default withTranslations(LastNameDOBLicenseLicenseState, "form.traffic.nassauLicenseSearch")
